"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateFinnGlobalVar = exports.setupFinnGlobalVar = void 0;
function setupFinnGlobalVar(appNexusData) {
    window.FINN = window.FINN || {};
    window.FINN.banner = window.FINN.banner || {};
    window.FINN.banner.feed = appNexusData.feed;
    window.FINN.banner.feedString = appNexusData.feedString;
    window.FINN.banner.ssa = appNexusData.ssa;
    window.FINN.banner.ads = {};
    window.FINN.banner.override = '';
}
exports.setupFinnGlobalVar = setupFinnGlobalVar;
function updateFinnGlobalVar(creativeIds) {
    var overrideString = Object.keys(creativeIds).reduce(function (result, key) { return key + ":" + creativeIds[key] + "," + result; }, '');
    window.FINN = window.FINN || {};
    window.FINN.banner = window.FINN.banner || {};
    window.FINN.banner.ads = creativeIds;
    window.FINN.banner.override = "ast_override_div=" + overrideString;
}
exports.updateFinnGlobalVar = updateFinnGlobalVar;
